export const name = 'modelUpdatesInvoker' as const
export const ModelUpdatesInvoker = Symbol('modelUpdatesInvokerSymbol')
export const ModelUpdatesHandlersImplementor = Symbol('modelUpdatesHandlersImplementorSymbol')
export const ViewerBatchingManagerSymbol = Symbol('ViewerBatchingManager')
// Multi-bound: one per feature that registers editor VSM side effects (ADR-0001). Resolved at init so
// each implementor's watches register.
export const SideEffectsImplementorSymbol = Symbol('SideEffectsImplementor')
